import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {getModelForResourceType} from 'resources/modelRegistry';
import ArrayToReadableFragment from 'lib/hocs/arrayToReadableFragment';

import {Button, Card, Heading, Text} from '@albert-io/atomic';

import './class-card.scss';

const ClassroomMenuCard = ({classroom}) => {
  const id = classroom.getId();
  const slug = `/classes/${id}/my-assignments`;
  const name = classroom.getName();
  const teachers = classroom.getTeachers();
  const salutationsAndNamesArr = [
    ...teachers.map((teacher) => `${teacher.getSalutation()} ${teacher.getLastName()}`)
  ];
  const subject = classroom.getSubjects().first();
  const iconSlug = subject?.getLogoLocation().href;
  const curriculumArea = subject?.getCurriculumArea();
  const color = curriculumArea?.getColor();
  return (
    <Card as={Link} className='class-card' aria-labelledby={id} shadow='default' to={slug}>
      <div className='class-card__inner'>
        <Heading as='h3' className='u-mar-b_1' size='s' id={id}>
          {name}
        </Heading>
        <Text as='h4' className='u-font-weight_normal u-mar-b_0' emphasis='lowest'>
          <ArrayToReadableFragment arr={salutationsAndNamesArr} />
        </Text>
      </div>
      {iconSlug && color ? (
        <div className='class-card__corner'>
          <svg width='130' height='130' viewBox='0 0 130 130' fill='none'>
            <circle cx='66' cy='64' r='64' fill={color} />
            <image height='32' width='32' transform='translate(32,64)' xlinkHref={iconSlug} />
          </svg>
        </div>
      ) : null}
      <Button as='div' variant='outlined' className='class-card__btn'>
        Go to classroom
      </Button>
    </Card>
  );
};

ClassroomMenuCard.propTypes = {
  classroom: PropTypes.instanceOf(getModelForResourceType('student_classroom_v1'))
};

export default ClassroomMenuCard;
